<template>
  <div class="guanLianBox">
    <el-dialog title="导出月账单" :visible.sync="MonthVisible" width="40%" :close-on-click-modal="false" center>
      <div>
        <el-form label-width="120px" :rules="rules" :inline="true" :model="monthForm" class="demo-form-inline"
          ref="monthForm">
          <el-form-item label="导出月份:" prop="daochuMonth">
            <el-date-picker :picker-options="setMonthDisabled" size="mini" style="width:150px" value-format="yyyy-MM"
              v-model="monthForm.daochuMonth" type="month" placeholder="导出月份" @change='chengeMonth'>
            </el-date-picker>
          </el-form-item>
          <div>
            <el-form-item label="账单时间:" prop="billTimeStart">
              <el-date-picker v-model="monthForm.billTimeStart" size="mini" type="date" style="width:150px"
                value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item> -

            <el-form-item prop="billTimeEnd">
              <el-date-picker v-model="monthForm.billTimeEnd" size="mini" type="date" style="width:150px"
                value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>

        </el-form>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="monthNo">取 消</el-button>
        <el-button type="primary" @click="monthOK('monthForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getTMonthlyStatementConfig,

    getRelationCustomer
  } from '@/api/wms-stock'
  import {
    exportExcel
  } from '@/utils/fileDown.js'
  import DonMessage from '@/utils/message'
  import {
    getBtn
  } from '@/utils/getButton'

  export default {
    name: 'addDialog',
    data() {
      return {
        setMonthDisabled: {
          disabledDate(time) {
            // 获取当前的月份信息
            const date = new Date(); // 获取当前的时间基本信息，值是这样的： Tue Jul 20 2021 14:59:43 GMT+0800 (中国标准时间)
            const year = date.getFullYear(); // 获取当前年份，值是这样的： 2021
            let month = date.getMonth() + 1; // 获取当前月份，值是这样的： 6   getMonth()方法返回值是0-11，也就是1月份到12月份，所以要加上1，才是当前月份
            if (month >= 1 && month <= 9) {
              // 如果是1月到9月就要在前面补上一个0   比如：02、07    月份这样表示
              month = "0" + month;
            }
            const nowDate = year.toString() + month
              .toString(); // 转换成字符串拼接，最终得到年和月，比如此时的时间是2021年7月20号，所以nowDate的值是：202107

            // 获取时间选择器的月份信息
            const timeyear = time.getFullYear(); // 获取时间选择器的年份（有很多）
            let timemonth = time.getMonth() + 1; // 与上面同理
            if (timemonth >= 1 && timemonth <= 9) {
              timemonth = "0" + timemonth;
            }
            const elTimeData = timeyear.toString() + timemonth.toString();

            // 返回，时间选择器的日期月份大于当前日期的月份，又因为disabledDate函数是控制月份禁用不可选
            // 所以，最终就是：时间选择器的月份大于当前的月份，就都禁用掉，所以就实现了最终效果：
            // 大于等于当前月份都不可选 
            return elTimeData >= nowDate; // 这里虽然是字符串，但是弱类型语言js会做一个转换，是可以比较大小的如： '202107' > '202008'
          }
        },
        monthForm: {},
        rules: {
          billTimeStart: [{
            required: true,
            message: '请选择开始时间',
            trigger: 'change'
          }, ],
          billTimeEnd: [{
            required: true,
            message: '请选择结束时间',
            trigger: 'change'
          }, ],
          daochuMonth: [{
            required: true,
            message: '请选择导出月份',
            trigger: 'change'
          }, ],

        },
      }
    },
    props: {
      titleFlag: {
        type: String,
      },
      MonthVisible: {
        type: Boolean,
        default: false
      },
    },

    created() {
      this.getTMonthlyStatementConfigS()
    },
    mounted() {},
    methods: {
      chengeMonth() {
        this.getTMonthlyStatementConfigS()
      },
      getTMonthlyStatementConfigS() {
        getTMonthlyStatementConfig({})
          .then((res) => {
            console.log(this.monthForm.daochuMonth, 'this.monthForm.daochuMonth')
            if (this.monthForm.daochuMonth && this.monthForm.daochuMonth !== '') {
              var t2 = this.monthForm.daochuMonth + '-';
              var arr = this.monthForm.daochuMonth.split('-');
              var year = arr[0]; //获取当前日期的年份
              var month = arr[1]; //获取当前日期的月份
              var month2 = parseInt(month) + 1;
              if (month2 == 13) {
                year = parseInt(year) + 1;
                month2 = 1;
              }
              var day2 = day;
              var days2 = new Date(year, month2, 0);
              days2 = days2.getDate();
              if (day2 > days2) {
                day2 = days2;
              }
              if (month2 < 10) {
                month2 = '0' + month2;
              }
              var t2 = year + '-' + month + '-';

              var t3 = year + '-' + month2 + '-';
            } else {
              // 获取上一个月
              var arr = new Date().toLocaleDateString().split('/');
              var year = arr[0]; //获取当前日期的年份
              var month = arr[1]; //获取当前日期的月份
              var day = arr[2]; //获取当前日期的日
              var days = new Date(year, month, 0);
              days = days.getDate(); //获取当前日期中月的天数
              var year2 = year;
              var month2 = parseInt(month) - 1;
              if (month2 == 0) {
                year2 = parseInt(year2) - 1;
                month2 = 12;
              }
              var month3 = parseInt(month2) + 1;
              if (month3 == 0) {
                year2 = parseInt(year2) - 1;
                month3 = 12;
              }
              var day2 = day;
              var days2 = new Date(year2, month2, 0);
              days2 = days2.getDate();
              if (day2 > days2) {
                day2 = days2;
              }
              if (month2 < 10) {
                month2 = '0' + month2;
              }
              if (month3 < 10) {
                month3 = '0' + month3;
              }
              var t2 = year2 + '-' + month2 + '-';
              var t3 = year2 + '-' + month3 + '-';
            }
            //             executionFlag
            // 是否自动生成账单:0 否 1 是
            if (res !== null && res.executionFlag == '1') {
              if (res.startDay < 10) {
                res.startDay = '0' + res.startDay;
              }
              // 开始日为1.结束日为最后一天
              if (this.monthForm.daochuMonth && this.monthForm.daochuMonth !== '') {
                month = parseInt(month);
              } else {
                month = parseInt(month) - 1;
              }
              if (res.startDay == '01') {
                var str2 = new Date(year, month, 0).getDate()
                this.$set(this.monthForm, 'daochuMonth', t2)
                this.$set(this.monthForm, 'billTimeStart', t2 + res.startDay)
                this.$set(this.monthForm, 'billTimeEnd', t2 + str2)

              } else {
                var date1 = new Date(t3 + res.startDay)
                var date2 = new Date(date1.getTime() - 24 * 60 * 60 * 1000)
                var y2 = date2.getFullYear();
                var m2 = date2.getMonth() + 1 < 10 ? "0" + (date2.getMonth() + 1) : date2.getMonth() + 1;
                var d2 = date2.getDate() < 10 ? "0" + date2.getDate() : date2.getDate();
                var str2 = y2 + "-" + m2 + "-" + d2
                this.$set(this.monthForm, 'daochuMonth', t2)
                this.$set(this.monthForm, 'billTimeStart', t2 + res.startDay)
                this.$set(this.monthForm, 'billTimeEnd', str2)
              }
            } else {
              var date1 = new Date(t3 + '01')
              var date2 = new Date(date1.getTime() - 24 * 60 * 60 * 1000)
              var y2 = date2.getFullYear();
              var m2 = date2.getMonth() + 1 < 10 ? "0" + (date2.getMonth() + 1) : date2.getMonth() + 1;
              var d2 = date2.getDate() < 10 ? "0" + date2.getDate() : date2.getDate();
              var str2 = y2 + "-" + m2 + "-" + d2
              this.$set(this.monthForm, 'daochuMonth', t2)
              this.$set(this.monthForm, 'billTimeStart', t2 + '01')
              this.$set(this.monthForm, 'billTimeEnd', str2)
            }
          })
          .catch((err) => {
            DonMessage.error(err.message)
          })
      },
      monthNo() {
        this.$emit('colseDialog', false)
      },
      monthOK(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var a = (new Date(this.monthForm.billTimeStart)).getTime()
            var b = (new Date(this.monthForm.billTimeEnd)).getTime()
            if (a > b) {
              this.$message.error('结束时间不能小于开始时间')
            } else {
              if (this.titleFlag == '卷板') {
                exportExcel(
                  this.global.wmsStockName + '/storageFee/exportMonthFeeList', {
                    billTimeStart: this.monthForm.billTimeStart,
                    billTimeEnd: this.monthForm.billTimeEnd
                  },
                  '卷板月账单明细表'
                )
                this.$emit('colseDialog', false)

              } else {
                exportExcel(
                  this.global.wmsStockName + '/storageFee/exportJcMonthFeeList', {
                    billTimeStart: this.monthForm.billTimeStart,
                    billTimeEnd: this.monthForm.billTimeEnd
                  },
                  '建材月账单明细表'
                )
                this.$emit('colseDialog', false)

              }
            }

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },

    },

  }

</script>

<style lang="less" scoped>
  /deep/ .el-form-item {
    margin: 0px;
  }

</style>
